var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
        _vm.applicant &&
          _vm.applicant.applicantId != -1 &&
          _vm.applicantVisits &&
          _vm.applicantVisits.length > 0
      )?_c('patient-body',{attrs:{"permissions":_vm.permissions}}):_vm._e(),_c('user-permissions-rn'),_c('user-permissions'),_c('als-trigger'),_c('patient-history',{attrs:{"isRescueNet":_vm.isRN2PLApp}}),_c('down-payor-list'),_c('input',{attrs:{"type":"hidden","id":"custId","name":"custId","value":"3487"},on:{"change":function($event){return _vm.doStuff()}}}),_c('footer_view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }